var _tspan, _tspan2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShipiq = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "100%",
  height: "100%",
  viewBox: "0 0 200 81",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xmlSpace: "preserve",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeMiterlimit: 1.5
  },
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(0.933333,0,0,0.897959,1.93333,5.53061)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 29,
  y: 15,
  width: 30,
  height: 49,
  style: {
    fill: "white"
  }
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1,0,0,1,-230.037,-190.439)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(0.977708,0,0,0.977708,5.61621,6.05521)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(3.71962,0,0,3.71962,-784.919,-824.748)"
}, /*#__PURE__*/React.createElement("text", {
  x: "293.155px",
  y: "288.336px",
  style: {
    fontFamily: "'Futura-Medium', 'Futura', sans-serif",
    fontWeight: 500,
    fontSize: 12
  }
}, "S"), /*#__PURE__*/React.createElement("text", {
  x: "299.551px",
  y: "288.336px",
  style: {
    fontFamily: "'Futura-Medium', 'Futura', sans-serif",
    fontWeight: 500,
    fontSize: 12
  }
}, "h", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
  x: "305.531px 307.919px ",
  y: "288.336px 288.336px "
}, "ip")))), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1,0,0,1,225.391,-101.467)"
}, /*#__PURE__*/React.createElement("text", {
  x: "158.651px",
  y: "348.221px",
  style: {
    fontFamily: "'Futura-Medium', 'Futura', sans-serif",
    fontWeight: 500,
    fontSize: "44.635px"
  }
}, "I", _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
  x: "169.583px ",
  y: "348.221px "
}, "Q"))))), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(0.833749,0,0,0.484046,86.0964,154.025)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M216.427,110L240.854,134.427L216.427,158.854L192,134.427L216.427,110Z",
  style: {
    fill: "rgb(255,9,0)"
  }
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(0.420486,0.728303,-0.438923,0.253412,224.527,45.0744)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M216.427,110L240.854,134.427L216.427,158.854L192,134.427L216.427,110Z",
  style: {
    fill: "rgb(0,7,255)"
  }
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.30333,0,0,1.30333,55.7172,55.9573)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M161.759,111.482L181.469,122.862L181.469,145.621L161.759,157L142.049,145.621L142.049,122.862L161.759,111.482Z",
  style: {
    fill: "none",
    stroke: "black",
    strokeWidth: "9.21px"
  }
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgShipiq);
export default ForwardRef;